export const FEATURES_DONE_OR_SKIP = 'FEATURES_DONE_OR_SKIP'

export function markAsSeen(pages){
	return {
		type: FEATURES_DONE_OR_SKIP,
		lastSeen: Math.max(...pages.map(x => x.id))
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/features.js